<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">
      <!-- Brand logo-->
      <b-link class="brand-logo">
        <vuexy-logo />
        <!-- <h2 class="brand-text text-primary ml-1">
          #Klinik Patnal
        </h2> -->
      </b-link>
      <!-- /Brand logo-->

      <!-- Left Text-->
      <b-col lg="8" class="d-none d-lg-flex align-items-center p-5">
        <div class="w-100 d-lg-flex align-items-center justify-content-center px-5">
          <b-img fluid :src="imgUrl" alt="Register V2" />
        </div>
      </b-col>
      <!-- /Left Text-->

      <!-- Register-->
      <b-col lg="4" class="d-flex align-items-center auth-bg px-2 p-lg-5">
        <b-row class="mt-5 mt-lg-0">
          <b-col sm="8" md="6" lg="12" class="px-xl-2 mx-auto pt-5 pt-lg-0">
            <b-card-title class="mb-1 pt-xs-100">
              Daftar Sekarang
            </b-card-title>
            <b-card-text class="mb-2">
              Segera mendaftarkan diri untuk pengusulan konsultasi. Lengkapi profil anda untuk
              mendaftar.
            </b-card-text>

            <!-- form -->
            <validation-observer ref="registerForm" #default="{invalid}">
              <b-form class="auth-register-form mt-2" @submit.prevent="register">
                <b-form-group label="Daftar Sebagai" label-for="register-as">
                  <validation-provider
                    #default="{ errors }"
                    name="Register Sebagai"
                    vid="register-as"
                    rules="required"
                  >
                    <v-select
                      id="register-as"
                      v-model="registerAs"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      label="title"
                      :options="registerOption"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
                <!-- name -->
                <b-form-group label="Nama Lengkap" label-for="register-name">
                  <validation-provider
                    #default="{ errors }"
                    name="Nama Lengkap"
                    vid="name"
                    rules="required"
                  >
                    <b-form-input
                      id="register-name"
                      v-model="userFullName"
                      name="register-name"
                      :state="errors.length > 0 ? false : null"
                      placeholder=""
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>

                <b-form-group label="NIP" label-for="register-username">
                  <validation-provider
                    #default="{ errors }"
                    name="NIP"
                    vid="nip"
                    rules="required|digits:18"
                  >
                    <cleave
                      id="register-nip"
                      v-model="nip"
                      name="register-nip"
                      :raw="false"
                      class="form-control"
                      :state="errors.length != 18 ? false : null"
                      :options="cleveNumber"
                      autocomplete="off"
                      placeholder=""
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>

                <b-form-group label="HP / Telepon" label-for="register-handphone">
                  <validation-provider
                    #default="{ errors }"
                    name="HP / Telepon"
                    vid="handphone"
                    rules="required"
                  >
                    <cleave
                      id="register-handphone"
                      v-model="handphone"
                      name="register-handphone"
                      :raw="false"
                      class="form-control"
                      :state="errors.length > 0 ? false : null"
                      :options="clevePhone"
                      placeholder=""
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>

                <validation-provider
                  #default="{ errors }"
                  name="Sekretariat/Direktorat"
                  rules="required"
                  v-if="registerAs === 'Ditjenpas'"
                >
                  <b-form-group label="Sekretariat/Direktorat" label-for="struktur_organisasi">
                    <v-select
                      v-model="strukturOrganisasi"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="strukturOrganisasiOptions.options"
                      :reduce="val => val.value"
                      :clearable="false"
                      input-id="struktur_organisasi"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </b-form-group>
                </validation-provider>

                <validation-provider
                  #default="{ errors }"
                  name="Wilayah"
                  rules="required"
                  v-if="registerAs === 'Kanwil' || registerAs === 'UPT'"
                >
                  <b-form-group label="Wilayah" label-for="wilayah">
                    <v-select
                      v-model="wilayah"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="kanwilOptions.options"
                      :reduce="val => val.value"
                      :clearable="false"
                      input-id="wilayah"
                      @input="val => changeUPT(val)"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </b-form-group>
                </validation-provider>

                <validation-provider
                  #default="{ errors }"
                  name="UPT"
                  rules=""
                  v-if="registerAs === 'UPT'"
                >
                  <b-form-group label="UPT" label-for="upt">
                    <v-select
                      v-model="upt"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="uptOptions.options"
                      :reduce="val => val.value"
                      :clearable="false"
                      input-id="upt"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </b-form-group>
                </validation-provider>

                <!-- email -->
                <b-form-group label="Email" label-for="register-email">
                  <validation-provider
                    #default="{ errors }"
                    name="Email"
                    vid="email"
                    rules="required|email"
                  >
                    <b-form-input
                      id="register-email"
                      v-model="userEmail"
                      name="register-email"
                      :state="errors.length > 0 ? false : null"
                      placeholder=""
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>

                <!-- password -->
                <b-form-group label-for="register-password" label="Password">
                  <validation-provider
                    #default="{ errors }"
                    name="Password"
                    vid="password"
                    rules="required"
                  >
                    <b-input-group
                      class="input-group-merge"
                      :class="errors.length > 0 ? 'is-invalid' : null"
                    >
                      <b-form-input
                        id="register-password"
                        v-model="password"
                        class="form-control-merge"
                        :type="passwordFieldType"
                        :state="errors.length > 0 ? false : null"
                        name="register-password"
                        placeholder="············"
                        v-on:keyup="validatePassword"
                      />
                      <b-input-group-append is-text>
                        <feather-icon
                          :icon="passwordToggleIcon"
                          class="cursor-pointer"
                          @click="togglePasswordVisibility"
                        />
                      </b-input-group-append>
                    </b-input-group>
                    <!-- <small class="text-danger">{{ errors[0] }}</small> -->
                    <pre v-if="password">Password Length {{ password.length }}</pre>
                    <p v-if="errors_password.length" style="color:red">{{ errors_password[0] }}</p>
                  </validation-provider>
                </b-form-group>

                <b-form-group>
                  <VueRecaptcha
                    @verify="markRecaptchaAsVerified"
                    @expired="onCaptchaExpired"
                    sitekey="6Les8QssAAAAAOpXlHSvvdtFfo_tnuXVl78-nIjw"
                  />
                </b-form-group>

                <b-form-group>
                  <b-form-checkbox id="register-privacy-policy" v-model="status" name="checkbox-1">
                    Saya setuju untuk mengikuti
                    <b-link v-b-modal.modal-default
                      >syarat dan kondisi kebijakan data privasi</b-link
                    >
                  </b-form-checkbox>
                </b-form-group>

                <b-button variant="primary" block type="submit" :disabled="invalid">
                  Daftar Sekarang
                </b-button>
              </b-form>
            </validation-observer>

            <p class="text-center mt-2">
              <span>Sudah memiliki akun?</span>
              <b-link :to="{ name: 'auth-login' }">
                <span>&nbsp;Masuk Sekarang</span>
              </b-link>
            </p>

            <b-modal
              id="modal-default"
              ok-only
              ok-title="Saya Setuju"
              centered
              size="lg"
              title="Syarat & Kondisi"
            >
              <b-card-text>
                <p>
                  Kami akan mengggunakan sumber daya yang kami miliki secara wajar untuk memastikan
                  semua proses bisnis pekerjaan yang lakukan aman termasuk dalam pengumpulan,
                  pengolahan, penyimpanan,penggunaan dan distribusi data. Kebijakan Perlindungan
                  data kami menegaskan, bahwa kami tidak akan memberikan ruang dan tidak
                  mentolersansi segala bentuk tindakan, disengaja atau tidak disengaja yang
                  menyebabkan rusak, hilang,penyalahgunaan,pengalihan data dan distribusi data yang
                  tidak sesuai kebijakan.
                </p>
                <p>
                  Kami memiliki kewajiban terhadap data-data partisipan program yang kami simpan:
                </p>
                <ol>
                  <li>
                    Dilindungi dengan system Perlindungan data secara baik ( enscripsy,mekanisme
                    akses.., )
                  </li>
                  <li>Mengikuti peraturan perundangan yang berlaku di Indonesia.</li>
                  <li>
                    endapat persetujuan mengenai pengumpulan, penggunaan, distribusi dari pemilik
                    data.
                  </li>
                  <li>
                    Tidak mengekspose data pribadi yang sensitive yang bisa digunakan untuk
                    mengidentifikasi lokasi, dan profile pemilik data.
                  </li>
                  <li>
                    Hanya digunakan sesuai kesepakatan dalam persetujuan, dan penggunaan diluar
                    tujuan awal harus mendapat ulang dari pemilik data.
                  </li>
                  <li>
                    Setiap data yang tidak lagi digunakan sesuai durasi kegiatan maka data akan;
                    dikembalikan kepada pemilik data atau dihancurkan sesuai ketentuan dalam
                    kebijakan Perlindungan data.
                  </li>
                </ol>
                <p>Setiap Pemilik data memiliki Hak:</p>
                <ol>
                  <li>Memastikan penyimpanan, penggunaan, dan distribusi data sesuai ketentuan</li>
                  <li>Membatalkan persetujuan, meski diawal sudah memberikan persetujuan.</li>
                  <li>Meminta sebagian atau beberapa data untuk dianonimkan</li>
                  <li>
                    Membawa ke proses hukum di negara Republik Indonesia jika terbukti terjadi
                    pelanggaran kebijakan atau tidak sesuai perundangan di negara RI.
                  </li>
                </ol>
                <p>
                  Setelah membaca hal diatas, dengan penuh kesadaran dan pemahaman saya menyatakan
                  setuju data-data saya dipergunakan untuk kepentingan klinik patnal.
                </p>
              </b-card-text>
            </b-modal>
            <!-- divider -->
            <!-- <div class="divider my-2">
              <div class="divider-text">
                or
              </div>
            </div>

            <div class="auth-footer-btn d-flex justify-content-center">
              <b-button
                variant="facebook"
                href="javascript:void(0)"
              >
                <feather-icon icon="FacebookIcon" />
              </b-button>
              <b-button
                variant="twitter"
                href="javascript:void(0)"
              >
                <feather-icon icon="TwitterIcon" />
              </b-button>
              <b-button
                variant="google"
                href="javascript:void(0)"
              >
                <feather-icon icon="MailIcon" />
              </b-button>
              <b-button
                variant="github"
                href="javascript:void(0)"
              >
                <feather-icon icon="GithubIcon" />
              </b-button>
            </div> -->
          </b-col>
        </b-row>
      </b-col>
      <!-- /Register-->
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import VuexyLogo from '@/views/layouts/components/Logo.vue'
import {
  BRow,
  BCol,
  BLink,
  BButton,
  BForm,
  BFormCheckbox,
  BFormGroup,
  BFormInput,
  BInputGroup,
  BInputGroupAppend,
  BImg,
  BCardTitle,
  BCardText,
  BModal,
  VBModal,
} from 'bootstrap-vue'
import { required, email } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import store from '@/store/index'
import router from '@/router'
import { getKanwil, getUPT, getStrukturOrganisasi } from '@/connection-api/master'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import Cleave from 'vue-cleave-component'

// eslint-disable-next-line import/no-extraneous-dependencies
import 'cleave.js/dist/addons/cleave-phone.us'

import { Authregister } from '@/connection-api/authentication'

import { VueRecaptcha } from 'vue-recaptcha'

export default {
  components: {
    VueRecaptcha,
    VuexyLogo,
    BRow,
    BImg,
    BCol,
    BLink,
    BButton,
    BForm,
    BCardText,
    BCardTitle,
    BFormCheckbox,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
    vSelect,
    // validations
    ValidationProvider,
    ValidationObserver,
    BModal,
    // flatPickr,
    Cleave,
  },
  directives: {
    'b-modal': VBModal,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      status: '',
      errors_password: [],
      validate_errors_password: 0,
      userFullName: '',
      handphone: '',
      userEmail: '',
      password: '',
      sideImg: require('@/assets/images/pages/register-v2.png'),
      // validation
      required,
      email,
      strukturOrganisasi: '',
      nip: '',
      // dob: '',
      // gender: 'Laki-laki',
      // genderOption: ['Laki-laki', 'Perempuan'],
      recaptchaVerified: false,
      pleaseTickRecaptchaMessage: '',
      registerAs: 'UPT',
      registerOption: ['UPT', 'Kanwil', 'Ditjenpas'],
      applicationToken: null,
      wilayah: '',
      upt: '',
      strukturOrganisasiOptions: {
        selected: 'id',
        options: [{ value: null, label: '--Sekretariat/Direktorat--' }],
      },
      kanwilOptions: {
        selected: 'id',
        options: [{ value: null, label: '--Pilih Jenis Kanwil --' }],
      },
      uptOptions: {
        selected: 'id',
        options: [{ value: null, label: '--Pilih UPT --' }],
      },
      clevePhone: {
        phone: true,
        phoneRegionCode: 'ID',
      },
      cleveNumber: {
        blocks: [18],
        numericOnly: true,
      },
      recaptcha: '',
    }
  },
  async mounted() {
    this.applicationToken = router.currentRoute.params.token
    const responseStrukturOrganisasiOptions = await getStrukturOrganisasi()
    this.mappingSelectOption(
      responseStrukturOrganisasiOptions.data,
      this.strukturOrganisasiOptions.options,
    )
    const responseKanwilOptions = await getKanwil()
    this.mappingSelectOption(responseKanwilOptions.data, this.kanwilOptions.options)
    this.reloadUPTOptions()
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require('@/assets/images/pages/register-v2.png')
        return this.sideImg
      }
      return this.sideImg
    },
  },
  methods: {
    markRecaptchaAsVerified(recaptchaToken) {
      this.recaptcha = recaptchaToken
      this.pleaseTickRecaptchaMessage = ''
      this.recaptchaVerified = true
    },
    onCaptchaExpired() {
      this.recaptcha = ''
      this.pleaseTickRecaptchaMessage = ''
      this.recaptchaVerified = false
    },
    changeUPT(value) {
      this.reloadUPTOptions(value)
    },
    async reloadUPTOptions(kanwilId) {
      this.uptFilter = null
      this.uptOptions = {
        selected: 'id',
        options: [{ value: null, label: '--Pilih UPT --' }],
      }
      const responseUptOptions = await getUPT(kanwilId)
      this.mappingSelectOption(responseUptOptions.data, this.uptOptions.options)
    },
    mappingSelectOption(master, name) {
      if (master.length > 0) {
        master.forEach(element => {
          name.push({
            label: element.nama,
            value: element.id,
          })
        })
      }
    },
    makeToast(variant = null, message = null, title = null) {
      this.$bvToast.toast(message, {
        title: 'Registrasi',
        variant,
        solid: true,
        autoHideDelay: 10000,
        enableHtml: true,
        allowHtml: true,
      })
    },
    validatePassword() {
      // console.log(this.password)
      this.errors_password = []
      if (!this.password) {
        this.errors_password.push('Password is required')
        this.validate_errors_password = 1
      } else if (this.password.length < 8) {
        this.errors_password.push('Password must be at least 8 characters long')
        this.validate_errors_password = 1
      } else if (!/\d/.test(this.password)) {
        this.errors_password.push('Password must contain at least one number')
        this.validate_errors_password = 1
      } else if (!/[a-z]/.test(this.password)) {
        this.errors_password.push('Password must contain at least one lowercase letter')
        this.validate_errors_password = 1
      } else if (!/[A-Z]/.test(this.password)) {
        this.errors_password.push('Password must contain at least one uppercase letter')
        this.validate_errors_password = 1
        // } else if (!/[!@#$%^&*()_+\-.{}[\]~]/.test(this.password)) {
      } else if (!/[!@#$%^&*]/.test(this.password)) {
        // this.errors_password.push('Password must contain at least one symbol (!@#$%^&*()_+-.[]~)')
        this.errors_password.push('Password must contain at least one symbol (!@#$%^&*)')
        this.validate_errors_password = 1
      } else {
        this.validate_errors_password = 0
      }

      // console.log(this.errors_password[0])
    },
    register() {
      if (this.validate_errors_password === 1) {
        this.makeToast('danger', this.errors_password[0])
      } else if (!this.recaptchaVerified) {
        this.pleaseTickRecaptchaMessage = 'Please tick recaptcha.'
        this.makeToast('danger', this.pleaseTickRecaptchaMessage)
      } else {
        this.$refs.registerForm.validate().then(success => {
          if (success) {
            Authregister({
              full_name: this.userFullName,
              handphone: this.handphone,
              struktur_organisasi: this.strukturOrganisasi,
              nip: this.nip,
              wilayah: this.wilayah,
              upt: this.upt,
              email: this.userEmail,
              password: this.password,
              password_confirmation: this.password,
              register_as: this.registerAs,
              recaptcha: this.recaptcha,
            })
              .then(response => {
                if (response.data.status.code === '00') {
                  if (this.applicationToken === '') {
                    this.$router.replace('login').then(() => {
                      this.$toast({
                        component: ToastificationContent,
                        position: 'top-right',
                        props: {
                          title: `Welcome ${this.userFullName || this.username}`,
                          icon: 'CoffeeIcon',
                          variant: 'success',
                          text: 'Anda telah berhasil mendaftar. Sekarang Anda dapat mulai masuk!',
                        },
                      })
                    })
                  } else {
                    this.$router
                      .replace({
                        name: 'auth-login-token',
                        params: { token: this.applicationToken },
                      })
                      .then(() => {
                        this.$toast({
                          component: ToastificationContent,
                          position: 'top-right',
                          props: {
                            title: `Welcome ${this.userFullName || this.username}`,
                            icon: 'CoffeeIcon',
                            variant: 'success',
                            text: 'Anda telah berhasil mendaftar. Sekarang Anda dapat mulai masuk!',
                          },
                        })
                      })
                  }
                } else {
                  this.makeToast('danger', response.data.data)
                }
              })
              .catch(error => {
                // this.$refs.registerForm.setErrors(error.response.data.error)
              })
          }
        })
      }
    },
  },
}
/* eslint-disable global-require */
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
